import styles from './MobileLanding.module.sass';

function MobileLanding() {
  // const { os } = this.props;
  // TODO Improvements use `navigator.language` and support different
  // languages on this mobile landing page
  const language = 'en';

  return (
    <div className={styles.scroll}>
      <div className={styles.mobileLanding}>
        <img className={styles.solinkLogo} src="/images/large-solink.png" />
        <div className={styles.content}>
          <div className={styles.text}>
            <p>This site is designed for desktops.</p>
            <p>Please use our mobile app for the best experience on your device.</p>
          </div>
          <div className={styles.storeBadges}>
            <a href="https://apps.apple.com/ca/app/solink/id1039916820">
              <img src={`/images/ios-app-store-${language}.png`} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.solinkcorp.solink">
              <img src={`/images/google-play-badge-${language}.png`} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileLanding;
